import { Modal, RichTextEditor, Space, Title } from 'ui';
import { useChangelogData } from './hooks';

const ChangelogModal = ({ isOpened, onClose }: { isOpened: boolean; onClose: () => void }) => {
  const { data, updateLatestWhatIsNewVersion } = useChangelogData();

  const handleCancel = () => {
    updateLatestWhatIsNewVersion();
    onClose();
  };

  return (
    <Modal
      title="What's new"
      isOpened={isOpened}
      maskClosable={false}
      width="large"
      disableBack
      onCancel={handleCancel}
    >
      <Space direction="vertical" size="middle">
        {data.map((version) => (
          <div key={version.version}>
            <Title item={{ level: 3 }}>{version.version}</Title>
            <RichTextEditor editable={false} data={version.htmlContent} />
          </div>
        ))}
      </Space>
    </Modal>
  );
};

export default ChangelogModal;
